/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Avatar } from "antd";

import * as actions from "../../../../../app/modules/Dashboard/_redux/dashboard/dashboardActions";
import { BG_TASK_NAME_BG, CELERY_INTEGER_TASK_ID } from "../../../../../app/modules/Common/constants";
const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

export function JobNotificationsDropdown() {
  const dispatch = useDispatch();

  useEffect(() => {
    getJobNotificationList();
  }, []);

  const { currentState } = useSelector((state) => ({ currentState: state.dashboard }), shallowEqual);

  const { jobEntities } = currentState;
  const getJobNotificationList = () => {
    dispatch(actions.fetchJobNotificationList({ page: 1, page_size: 10 }));
  };
  function formatNotificationName(notificationName) {
    return notificationName
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  return (
    <>
      <div className="">
        <PerfectScrollbar options={perfectScrollbarOptions} className="notify scroll my-4" style={{ maxHeight: "600px", position: "relative" }}>
          {jobEntities.map((notification, key) => (
            <>
              <a
                key={key}
                className="notify-item"
              >
                <div className="notify-link">
                  <div className="mr-9">
                    <Avatar size={35} src={"/media/logos/JobAlert.svg"} style={{ backgroundColor: '#FDE8EE' }} />
                  </div>
                  <div className="list-text">
                    <div>
                      {formatNotificationName(BG_TASK_NAME_BG[notification.name] || notification.name)} has been{" "}
                      {CELERY_INTEGER_TASK_ID[notification.status].slug.toLowerCase()}
                    </div>
                    <div className="text-muted">
                      {notification?.result?.download_url && <a href={notification?.result?.download_url}>click here to download</a>}
                    </div>
                  </div>
                </div>
              </a>
            </>
          ))}
        </PerfectScrollbar>
      </div>
    </>
  );
}
